import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'antd';

import './styles.scss';

export class CollapseItem extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      open: props.isOpen,
    };

    this.togglePanel = this.togglePanel.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.isOpen !== prevProps.isOpen) {
      this.setState({ open: this.props.isOpen });
    }
  }

  togglePanel() {
    this.setState({ open: !this.state.open });
  }

  render() {
    const { title, children, description, withSpace, hasError, errorMessage, hasHtml, onClick } = this.props;

    const onClickHandler = () => {
      if (typeof onClick === 'function') {
        onClick()
      }

      this.togglePanel()
    }

    return (
      <>
      <div className="CollapseItem">
        <div onClick={onClickHandler} className="header">
            <span className="title">
              {title}
              {hasError &&
              <>
                <Icon type="warning" style={{marginLeft: '10px', color: '#ff4a50'}} />
                {errorMessage &&
                  <span className="text-danger small ml-2">{errorMessage}</span>
                }
              </>}
              </span>
              {description && (!errorMessage || !errorMessage.length) &&
                <span className="description">{description}</span>
              }
            <i
              className={
                !this.state.open ? 'float-right os-icon os-icon-arrow-down3 icon'
                  : 'float-right os-icon os-icon-arrow-up4 icon'}
            />
        </div>

        {hasHtml ?
          <div className={this.state.open ? "content" : "content content-hide"} dangerouslySetInnerHTML={{__html: children}} />
          :
          <div className={this.state.open ? "content" : "content content-hide"}>{children}</div>
        }
      </div>
        { this.state.open && withSpace ? <div className="CollapseItem-space"/> : null }
        </>
    );
  }
}

CollapseItem.defaultProps = {
  description: '',
  isOpen: false,
  withSpace: true,
  hasError: false,
  hasHtml: false,
};

CollapseItem.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.any.isRequired,
  description: PropTypes.string,
  withSpace: PropTypes.bool,
  isOpen: PropTypes.bool,
  hasError: PropTypes.bool,
  hasHtml: PropTypes.bool,
  onClick: PropTypes.func,
};

export default CollapseItem;
